// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2gMHD","cell":"ColumnAccessor_cell__1Wj5Z","firstCellAccent":"ColumnAccessor_firstCellAccent__2wgb_"};